import { IContact } from './contact';

export interface IContactListResponse {
    data: {
        success: boolean;
        message: string;
        results: IContact[];
    }
}
